import React, { Component } from 'react'
import TextInput from 'components/UI/TextInput'
import Button from 'components/UI/Button'
import { AccountPayloadType } from 'ducks/auth/types'
import { passwordValidation, validateEmail } from 'utils/helpers'
import {
  handleErrorMessageAlert,
  handleCloseAllAlerts
} from 'components/UI/Alert'
import {
  FormContainer,
  FormContent,
  FormFooter,
  FormTitle,
  FormWrapper
} from './styles'
import PrivacyPolicyCheckBox from '../../content/PrivacyPolicy/PrivacyPolicyCheckBox'
import ROUTES_PATH from '../../../routes/routePath'
import Link from '../../UI/Link'
import PhoneSelector from '../../UI/PhoneInput/PhoneInput'

interface IFormProps {
  onSubmit: (form: AccountPayloadType) => void
}

interface IErrorFields {
  firstName?: string
  lastName?: string
  email?: string
  password?: string
  confirmPassword?: string
  isChecked?: string
}

interface IFormState {
  form: AccountPayloadType
  errors: IErrorFields
}

class CreateAccountForm extends Component<IFormProps, IFormState> {
  constructor(props: IFormProps) {
    super(props)

    this.state = {
      form: {
        email: '',
        firstName: '',
        ipAddress: '127.0.0.1',
        lastName: '',
        middleInitial: '',
        password: '',
        confirmPassword: '',
        mobileNumber: '', //  phoneNumber
        termsAndConditionsId: 1,
        isChecked: true
      },
      errors: {}
    }
  }

  render() {
    const { errors } = this.state

    return (
      <FormWrapper>
        <FormContainer>
          <FormTitle>Create Account</FormTitle>
          <FormContent>
            <TextInput
              name={'firstName'}
              label={'First Name'}
              placeholder={'Enter First Name'}
              errorLabel={errors.firstName || ''}
              handleChange={this.onUpdate}
            />
            <TextInput
              name={'lastName'}
              label={'Last Name'}
              placeholder={'Enter Last Name'}
              errorLabel={errors.lastName || ''}
              handleChange={this.onUpdate}
            />
            <TextInput
              name={'email'}
              label={'Email Address'}
              placeholder={'Enter Email Address'}
              errorLabel={errors.email || ''}
              handleChange={this.onUpdate}
            />
            {/*<TextInput*/}
            {/*  name={'mobileNumber'}*/}
            {/*  label={'Phone Number (optional)'}*/}
            {/*  placeholder={'Enter Phone Number'}*/}
            {/*  handleChange={this.onUpdate}*/}
            {/*/>*/}
            <PhoneSelector
              label={'Phone Number (optional)'}
              placeholder="Enter phone number"
              name={'mobileNumber'}
              onChange={this.onUpdate}
              value={this.state.form.mobileNumber}
            />
            <TextInput
              name={'password'}
              type={'password'}
              label={'Password'}
              placeholder={'Enter Password'}
              errorLabel={errors.password || ''}
              tooltipText={'Account password. (Minimum length of 8 and must have minimum of 2 of lowercase, uppercase, numeric or other. Retry and History max is 10)'}
              handleChange={this.onUpdate}
            />
            <TextInput
              name={'confirmPassword'}
              type={'password'}
              label={'Repeat Password'}
              placeholder={'Repeat Password'}
              errorLabel={errors.confirmPassword || ''}
              tooltipText={'Confirm password. (Minimum length of 8 and must have minimum of 2 of lowercase, uppercase, numeric or other. Retry and History max is 10)'}
              handleChange={this.onUpdate}
            />
          </FormContent>
          <PrivacyPolicyCheckBox
            isCheck={this.onCheck}
            errorLabel={errors.isChecked || ''}
          />
        </FormContainer>
        <FormFooter>
          <Link variant={'text'} to={ROUTES_PATH.AUTH}>
            Back to Main Page
          </Link>
          <Button variant={'default'} onClick={this.onSubmit}>
            Create Account
          </Button>
        </FormFooter>
      </FormWrapper>
    )
  }
  private isValid = (): boolean => {
    const { form } = this.state
    const errors: IErrorFields = {}

    if (!form.firstName) {
      errors.firstName = 'You must enter at least firstName'
    }

    if (!form.lastName) {
      errors.lastName = 'You must enter at least lastName'
    }

    if (!validateEmail(form.email)) {
      errors.email = 'Invalid email address'
    }

    if (!form.email) {
      errors.email = 'You must enter at least email'
    }

    if (!form.password) {
      errors.password = 'You must enter at least password'
    }

    if (passwordValidation(form.password)) {
      // form.password && form.password.length < 8
      errors.password =
        'Please check your password. It must be longer 8 and include upper letters, ' +
        'lower letters, and number' // 'The password length is too small. Please try again.'
    }

    if (!errors.password && form.password && !form.confirmPassword) {
      errors.confirmPassword = 'You must enter at least confirmPassword'
    }

    if (!errors.password && form.password !== form.confirmPassword) {
      errors.confirmPassword = 'Passwords are not equal'
    }

    if (form.isChecked) {
      errors.isChecked = 'Need to accept Term of Services and Privacy Policy'
    }

    this.showAlertErrors(errors)

    this.setState({ errors })
    return !Object.keys(errors).length
  }

  private showAlertErrors = (errors: IErrorFields) => {
    Object.keys(errors).forEach(prop => {
      // @ts-ignore
      if (errors[prop]) {
        // @ts-ignore
        handleErrorMessageAlert(errors[prop])
      }
    })
  }

  private onUpdate = (name: string, value: string) => {
    this.setState((prevState: IFormState) => ({
      ...prevState,
      form: {
        ...prevState.form,
        [name]: value
      },
      errors: {
        ...prevState.errors,
        [name]: ''
      }
    }))
  }
  private onCheck = (value: boolean) => {
    this.setState((prevState: IFormState) => ({
      ...prevState,
      form: {
        ...prevState.form,
        isChecked: value
      },
      errors: {
        ...prevState.errors,
        isChecked: ''
      }
    }))
  }

  private onSubmit = async () => {
    const {
      form: { confirmPassword, ...account }
    } = this.state
    const acc = { ...account }
    delete acc.isChecked
    handleCloseAllAlerts()
    if (this.isValid()) {
      this.props.onSubmit(acc)
    }
  }
}

export default CreateAccountForm
